import { Component, OnInit, OnChanges, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';

import { WindowRef } from '../shared/utils/window-ref.service';
import { TrackingDocumentShowerService } from './services/tracking-document-shower.service';
import { JsonHttpService } from '../shared/http/json-http.service';
import { SvgIconComponent } from '../shared/icons/svg-icon.component';

@Component({
    selector: 'ep-tracking-document-shower',
    templateUrl: './tracking-document-shower.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SvgIconComponent]
})

export class TrackingDocumentShowerComponent implements OnChanges {

    @Input() fileType: string;
    @Input() documentId: number;
    @Input() interchangeInId: number;
    @Input() fileIdentifier: string;

    public isLoading = false;
    public token: string;

    constructor(private trackingDocumentShowerService: TrackingDocumentShowerService, private windowRef: WindowRef, private httpService: JsonHttpService) { }

    ngOnChanges(changes: any) {
        //if (changes.fileType || changes.documentId) {
        //    this.findToken();
        //}
    }

    showFile() {
        var window = this.windowRef.nativeWindow.open('', '_blank');
        if(this.documentId) {
            this.trackingDocumentShowerService.getDocumentShowToken(this.documentId, this.fileType, this.fileIdentifier).then(token => {
                let url = this.httpService.generateBackendUrl('/api/tracking/show-document/get-document-show-data/' + token);
                window.location = url;
            });
        } else if (this.interchangeInId) {
            this.trackingDocumentShowerService.getInterchangeInShowToken(this.interchangeInId, this.fileType, this.fileIdentifier).then(token => {
                let url = this.httpService.generateBackendUrl('/api/tracking/show-document/get-interchange-show-data/' + token);
                window.location = url;
            });
        }
    }

    //findToken() {
    //    if (this.documentId && this.fileType && this.fileIdentifier) {
    //        this.isLoading = true;
    //        this.trackingDocumentShowerService.getShowToken(this.documentId, this.fileType, this.fileIdentifier).then(token => {
    //            this.token = token;
    //            this.isLoading = false;
    //        });
    //    }
    //}
}
